import React from "react";
import "../../App.css";
import { formatClassNames } from "../../helpers/util";
import "./InputColumn.css";

export default function InputColumn({ children, className }) {
  return (
    <div className={formatClassNames("input-columns", className)}>
      {children}
    </div>
  );
}
